import add from "../../assets/icons/add.svg";
import remove from "../../assets/icons/remove.svg";
import { IconButton } from "@material-ui/core";
import { Add, Remove } from "@material-ui/icons";
import "./index.css";

const Counter = ({ value = 0, title = "", setValue = () => {} }) => {
  return (
    <div className="Counter flex align-center ">
      <label className="m-0 ml-2 text-normal">{title}</label>
      <div className="flex flex-center">
        <IconButton
          color="default"
          onClick={() => {
            setValue(value + 1);
          }}
        >
          <Add />
        </IconButton>
        <label className="m-0 mx-1 text-normal">{value}</label>
        <IconButton
          onClick={() => {
            if (value > 0) {
              setValue(value - 1);
            }
          }}
        >
          <Remove />
        </IconButton>
      </div>
    </div>
  );
};

export default Counter;
